import { defineComponent, h } from '@vue/composition-api';
import { withInstall } from '../util/index';
import { unknownProp } from '../util/props';
import { isDef, isNumeric } from '../util/validate';
import "../style/components/switch.css";

var addUnit = function addUnit(value) {
  if (isDef(value)) {
    return isNumeric(value) ? "".concat(value, "px") : String(value);
  }

  return undefined;
};

var Switch = defineComponent({
  name: 'm-switch',
  props: {
    size: {
      type: String,
      "default": ''
    },
    loading: {
      type: Boolean,
      "default": false
    },
    disabled: {
      type: Boolean,
      "default": false
    },
    modelValue: {
      type: unknownProp,
      "default": false
    },
    activeColor: {
      type: String,
      "default": '#ff4906'
    },
    inactiveColor: {
      type: String,
      "default": '#ffffff'
    },
    activeValue: {
      type: unknownProp,
      "default": true
    },
    inactiveValue: {
      type: unknownProp,
      "default": false
    }
  },
  model: {
    prop: 'modelValue',
    event: 'update'
  },
  emits: ['change', 'update'],
  setup: function setup(props, _ref) {
    var emit = _ref.emit,
        slots = _ref.slots;

    var isChecked = function isChecked() {
      return props.modelValue === props.activeValue;
    };

    var onClick = function onClick() {
      if (!props.disabled && !props.loading) {
        var newValue = isChecked() ? props.inactiveValue : props.activeValue;
        emit('update', newValue);
        emit('change', newValue);
      }
    };

    return function () {
      var _slots$node, _slots$background;

      var size = props.size,
          loading = props.loading,
          disabled = props.disabled,
          activeColor = props.activeColor,
          inactiveColor = props.inactiveColor;
      var checked = isChecked();
      var style = {
        fontSize: addUnit(size),
        backgroundColor: checked ? activeColor : inactiveColor
      };
      var switchOnStyle = {
        backgroundColor: 'red'
      };
      return h("div", {
        "attrs": {
          "role": "switch"
        },
        "class": {
          'm-switch': true,
          'm-switch-disabled': disabled,
          'm-switch-on': checked
        },
        "style": style,
        "on": {
          "click": onClick
        }
      }, [h("div", {
        "class": 'm-switch-node'
      }, [(_slots$node = slots.node) === null || _slots$node === void 0 ? void 0 : _slots$node.call(slots)]), (_slots$background = slots.background) === null || _slots$background === void 0 ? void 0 : _slots$background.call(slots)]);
    };
  }
});
withInstall(Switch);
export default Switch;